import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isCreateCaseModalVisible: false,
    UserDataFirms: {}
  },
  getters: {
    getIsCreateCaseModalVisible: (state) => state.isCreateCaseModalVisible,
    getUserDataFirms: (state) => state.UserDataFirms
  },
  mutations: {
    toggleCreateCaseModal (state) {
      state.isCreateCaseModalVisible = !state.isCreateCaseModalVisible
    },
    setUserDataFirms (state, payload) {
      if (payload.length > 0) {
        state.UserDataFirms = payload.map(entry => entry.firm)
      }
    }
  },
  actions: {
    async fetchUserDataFirms ({ commit }, userId) {
      let params = {
        pagination: false
      }
      const response = await new ApiService(`user_datas/${userId}/user_data_firms`, params).getResults()
      commit('setUserDataFirms', await response.items)
    }
  }
}
